import { getCurrentProfileId } from '../redux/profile/profile.selectors';

const addXProfileIdHeader = ({ getState }, req) => {
    const currentProfileId = getCurrentProfileId(getState());

    const cookies = Object.fromEntries(document.cookie.split('; ').map((c) => c.split('=')));

    return {
        ...req,
        withCredentials: true,
        headers: {
            ...req.headers,
            'X-Profile-Id': currentProfileId,
            'X-Fbp': cookies._fbp,
            'X-Fbc': cookies._fbc,
        },
    };
};

const multiClientMiddlewareConfig = {
    interceptors: {
        request: [addXProfileIdHeader],
    },
};

export default multiClientMiddlewareConfig;
